import type { IconData } from '@stacksjs/iconify-core'

export const dataTransferDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 464h480v32H16zm379.313-164.687l-22.626-22.626L280 369.373V16h-32v353.373l-92.687-92.686l-22.626 22.626L264 430.627z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default dataTransferDown
